import ManageSubscription from "common/components/subscriptions/ManageSubscription";
import { Dialog, DialogContent } from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import type { PRICING_PLANS } from "common/constants";
import usePricing from "common/datahooks/usePricing";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { PricingPeriodInfo } from "common/types";

export default function ManageSubscriptionDialog({
  isOpen,
  setIsOpen,
  ...rest
}: {
  plan: keyof typeof PRICING_PLANS;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  //if this is provided, this period is used, and pricing period selection is not available
  fixedPricingPeriodInfo?: PricingPeriodInfo;
  minQuantity?: number;
}) {
  const isDesktop = useTwBreakpoint("lg");
  usePricing();

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Content className="lg:w-fit">
        <ManageSubscription onClose={() => setIsOpen(false)} {...rest} />
      </Content>
    </Component>
  );
}
